import axios from 'axios'

const SET_SAMPLES = 'SET_SAMPLES'
const RESET = 'RESET'
const SET_DOCUMENTS = 'SET_DOCUMENTS'
const SET_SAMPLE = 'SET_SAMPLE'
const AddSampleDocument = 'AddSampleDocument'
const DeleteSampleDocument = 'DeleteSampleDocument'

const BASE_URL_getSamples = 'api/Sample/Activities/StationId/'
const BASE_URL_getSamplesByCocCode = 'api/Sample/Activities/CocCode/'
const BASE_URL_getDocumentsByImport = 'api/Sample/Documents/'
const BASE_URL_addSampleDocument = 'api/Sample/Documents/Add'
const BASE_URL_deleteSampleDocument = 'api/Sample/Documents/Delete/'
const BASE_URL_updateSample = 'api/Sample/Activities/Update'

function initialState() {
  return {
    samples: [],
    documents: [],
  }
}

export default {
  namespaced: true,

  state: initialState,

  actions: {
    async getSamples({ commit }, stationId) {
      let url = BASE_URL_getSamples + stationId
      axios.get(url)
        .then(res => {
          commit(SET_SAMPLES, res.data)
        })
        .catch(() => {
          console.log('Could not get sample data from \'' + url + '\'')
        })
    },

    async getSamplesByCocCode({ commit }, cocCode) {
      let url = BASE_URL_getSamplesByCocCode + cocCode
      axios.get(url)
        .then(res => {
          commit(SET_SAMPLES, res.data)
        })
        .catch(() => {
          console.log('Could not get sample data from \'' + url + '\'')
        })
    },

    async getDocumentsByImport({ commit }, ImportId) {
      try {
        let res = await axios.get(BASE_URL_getDocumentsByImport + ImportId)
        commit(SET_DOCUMENTS, res.data)
      } catch (error) {
        console.error(error)
        throw 'Failed to fetch import documents.'
      }
    },

    async addSampleDocument({ commit }, options) {
      axios.post(BASE_URL_addSampleDocument, options.data)
        .then(res => {
          commit(AddSampleDocument, res.data)
          options.successCb()
        })
        .catch(error => {
          options.failedCb(error)
        })
    },

    async deleteSampleDocument({ commit }, options) {
      let url = BASE_URL_deleteSampleDocument + options.sampleDocumentId
      axios.post(url)
        .then(() => {
          commit(DeleteSampleDocument, options.sampleDocumentId)
          options.successCb()
        })
        .catch(error => {
          options.failedCb(error)
        })
    },

    async updateSample({ commit }, sampleToUpdate) {
      let data = {
        Id: sampleToUpdate.Id,
        SampledBy: sampleToUpdate.SampledBy,
        Notes: sampleToUpdate.Notes,
      }
      axios.put(BASE_URL_updateSample, data)
        .then(() => {
          commit(SET_SAMPLE, sampleToUpdate)
        })
        .catch(() => {
          console.log('Could not get sample data from \'' + BASE_URL_updateSample + '\'')
        })
    },
  },

  mutations: {
    // The graphql result set is ready only and JSON clone is used
    // here to create a new object with writeable properties.
    [SET_SAMPLES](s, v) { s.samples = JSON.parse(JSON.stringify(v)) },
    [SET_DOCUMENTS](s, v) { s.documents = v },
    [SET_SAMPLE](s, v) {
      var m = s.samples.find(x => x.Id == v.Id)
      m.SampledBy = v.SampledBy
      m.Notes = v.Notes
    },
    [RESET](state) {
      const s = initialState()
      Object.keys(s).forEach(key => {
        state[key] = s[key]
      })
    },
    [AddSampleDocument](s, v) {
      s.documents.push(v)
    },
    [DeleteSampleDocument](s, v) {
      let target = s.documents.findIndex(x => x.Id == v)
      s.documents.splice(target, 1)
    },
  },

  getters: {
    samples: s => s.samples,
    documents: s => s.documents,
  },
}